module.exports = __webpack_public_path__ + "img/mt_s.c6b6bf34.png";